import { createDwellTimeListener } from '@jusbrasil-web/shared-dwell-time'
import { useEffect } from 'react'

import { MetricsProperties, pageOriginIsSerp } from '../metrics'

interface DocumentType {
  docId: number | undefined
  readingTime: number | null | undefined
}

interface SendMetricsType {
  (name: string, properties?: Record<string, unknown>): void
}

export const useDwellTime = (
  document: DocumentType | undefined,
  sendMetrics: SendMetricsType,
  metricsProperties: MetricsProperties
) => {
  // This hook should be run only once per page, that's why docId should be its only dependency
  useEffect(() => {
    if (!document) return

    const dwellTimeListener = createDwellTimeListener({
      callback: (data) => {
        sendMetrics('Doc.DwellTime', { ...metricsProperties, ...data })
        if (pageOriginIsSerp(metricsProperties)) {
          sendMetrics('Search.DwellTime', { ...metricsProperties, ...data })
        }
      },
      readingTimeSeconds: document?.readingTime || undefined,
    })
    dwellTimeListener.start()

    return () => {
      dwellTimeListener.stop()
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [document?.docId])
}
